<template>
    <div>

        <Head>
            <title>
                {{
                    $t('TITLES.cruises-with-delegate-detail', {
                        cruiseName: details?.name?.[LANGUAGE],
                    })
                }}
            </title>
            <meta name="description" :content="$t('META-DESCRIPTIONS.cruises-with-delegate-detail', {
                cruiseName: details?.name?.[LANGUAGE],
            })
                " />
        </Head>

        <header class="header-detail header-detail--cruises-delegate"
            :style="`background: url('${details?.heroImage}');background-size: cover;background-position: center;`">
            <div ref="sticky-header-offset">
                <div class="breadcrumbs breadcrumbs--cruises-delegate">
                    <ul class="breadcrumbs__inner">
                        <li class="breadcrumbs__item">
                            <router-link :to="{
                                path: '/',
                                query: $route.query,
                            }" class="breadcrumbs__link">
                                nautyy.{{
                                    LANGUAGE === 'cs'
                                        ? 'cz'
                                        : LANGUAGE === 'sk'
                                            ? 'sk'
                                            : ''
                                }}</router-link>
                        </li>
                        <li class="breadcrumbs__item">
                            <router-link :to="{
                                path: '/plavby-s-delegatem',
                                query: $route.query,
                            }" class="breadcrumbs__link">
                                {{ $t('LABELS.cruises-with-delegate') }}
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div :class="delegatePageStyles['cruises-delegate-detail-page__header']" ref="sticky-header-trigger">
                <div :class="delegatePageStyles['cruises-delegate-detail-page__header-inner']">
                    <div :class="delegatePageStyles['cruises-delegate-detail-page__header-split']">
                        <div
                            :class="[delegatePageStyles['cruises-delegate-detail-page__header-content'], { transport: includeTransport }]">
                            <div
                                :class="[delegatePageStyles['cruises-delegate-detail-page__header-part'], delegatePageStyles['cruises-delegate-detail-page__header-part--header']]">
                                <h3 :class="delegatePageStyles['cruises-delegate-detail-page__heading']">
                                    <div :class="delegatePageStyles['cruises-delegate-detail-page__subheading']">
                                        {{ details?.destinationName?.[LANGUAGE] || $t('STATUSES.loading') }}
                                    </div>
                                    <div>
                                        {{ details?.name?.[LANGUAGE] || $t('STATUSES.loading') }}
                                    </div>
                                </h3>
                            </div>
                            <div
                                :class="[delegatePageStyles['cruises-delegate-detail-page__header-part'], delegatePageStyles['cruises-delegate-detail-page__header-part--dates'], delegatePageStyles['cruises-delegate-detail-page__header-part--middle']]">
                                <h3 :class="delegatePageStyles['cruises-delegate-detail-page__mini-heading']">
                                    {{ $t('LABELS.sail-date') }}
                                </h3>
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__date']">
                                    <div :class="delegatePageStyles['cruises-delegate-detail-page__date-arrow']">→</div>
                                    <div>
                                        <div>
                                            {{ details?.departureDate ? formatDate(details.departureDate) :
                                                $t('STATUSES.loading') }}
                                        </div>
                                        <div>
                                            {{ details?.departureName?.[LANGUAGE] || $t('STATUSES.loading') }}
                                        </div>
                                    </div>
                                </div>
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__date']">
                                    <div :class="delegatePageStyles['cruises-delegate-detail-page__date-arrow']">←</div>
                                    <div>
                                        <div>
                                            {{ details?.arrivalDate ? formatDate(details.arrivalDate) :
                                                $t('STATUSES.loading') }}
                                        </div>
                                        <div>
                                            {{ details?.arrivalName?.[LANGUAGE] || $t('STATUSES.loading') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="[delegatePageStyles['cruises-delegate-detail-page__header-part'], delegatePageStyles['cruises-delegate-detail-page__header-part--middle'], delegatePageStyles['cruises-delegate-detail-page__header-part--middle-last']]">
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__header-part__row']">
                                    <h3 :class="delegatePageStyles['cruises-delegate-detail-page__mini-heading']">
                                        {{ $t('LABELS.total-time') }}
                                    </h3>
                                    <p :class="delegatePageStyles['cruises-delegate-detail-page__header-text']">
                                        {{ details?.days }}
                                        {{ daysInflected(details?.days) }}
                                    </p>
                                </div>
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__header-part__row']">
                                    <h3 :class="delegatePageStyles['cruises-delegate-detail-page__mini-heading']">
                                        {{ $t('LABELS.ship') }}
                                    </h3>
                                    <div
                                        :class="delegatePageStyles['cruises-delegate-detail-page__cruiser-name-container']">
                                        <p :class="delegatePageStyles['cruises-delegate-detail-page__cruiser-name']">
                                            {{ details?.ship_name?.[LANGUAGE] }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div
                                :class="[delegatePageStyles['cruises-delegate-detail-page__header-part'], delegatePageStyles['cruises-delegate-detail-page__header-part--prices']]">
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__notice']"
                                    v-if="details?.label?.[LANGUAGE] || !details">
                                    <svg :class="delegatePageStyles['cruises-delegate-detail-page__notice-icon']">
                                        <use href="@/assets/imgs/icons/sprite.svg#notice"></use>
                                    </svg>
                                    <span :class="delegatePageStyles['cruises-delegate-detail-page__notice-text']">
                                        {{ details?.label?.[LANGUAGE] || $t('STATUSES.loading') }}
                                    </span>
                                </div>
                            </div>
                            <div
                                :class="[delegatePageStyles['cruises-delegate-detail-page__header-part'], delegatePageStyles['cruises-delegate-detail-page__header-part--more-info']]">
                                <p :class="delegatePageStyles['cruises-delegate-detail-page__more-info-text']" v-html="$t('TEXTS.contact-cruise-text', {
                                    href: `/kontakt/`,
                                })
                                    "></p>
                            </div>
                            <SkeletonBox v-if="isLoading" height="15rem" :style="{
                                'grid-column': '1 / -1'
                            }" />
                            <div v-else
                                :class="[delegatePageStyles['cruises-delegate-detail-page__header-part'], delegatePageStyles['cruises-delegate-detail-page__header-part--transport']]"
                                v-if="includeTransport">
                                <h4>{{ $t('TEXTS.transport-to-tour') }}</h4>
                                <p v-if="this.details?.transportText?.[LANGUAGE]"
                                    v-html="this.details?.transportText?.[LANGUAGE]"></p>
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__transports']">
                                    <div :class="delegatePageStyles['cruises-delegate-detail-page__transport']" v-if="
                                        this.details?.transports?.plane?.[
                                        LANGUAGE
                                        ]
                                    ">
                                        <svg
                                            :class="delegatePageStyles['cruises-delegate-detail-page__transport__icon']">
                                            <use href="@/assets/imgs/icons/sprite.svg#plane"></use>
                                        </svg>
                                        <p>
                                            {{
                                                this.details?.transports?.plane?.[
                                                LANGUAGE
                                                ]
                                            }}
                                        </p>
                                    </div>
                                    <div :class="delegatePageStyles['cruises-delegate-detail-page__transport']" v-if="
                                        this.details?.transports?.bus?.[
                                        LANGUAGE
                                        ]
                                    ">
                                        <img :class="delegatePageStyles['cruises-delegate-detail-page__transport__icon']"
                                            src="@/assets/imgs/icons/bus.svg" />
                                        <p>
                                            {{ this.details?.transports?.bus?.[LANGUAGE] }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="delegatePageStyles['cruises-delegate-detail-page__header-column']">
                            <div :class="delegatePageStyles['cruises-delegate-detail-page__header-column-part']">
                                <div v-if="!isInitialized" class="cabin-delegate">
                                    <SkeletonBox class="cabin-delegate__type-select" :width="null" height="3rem" />
                                    <SkeletonBox class="cabin-delegate__remove-btn" :width="null" :height="null" />
                                    <SkeletonBox class="cabin-delegate__item" :height="null" />
                                    <SkeletonBox class="cabin-delegate__item" :height="null" />
                                    <SkeletonBox class="cabin-delegate__item" :height="null" />
                                    <div class="cabin-delegate__price-summary">
                                        <SkeletonBox class="cabin-delegate__text" />
                                        <SkeletonBox class="cabin-delegate__text" />
                                    </div>
                                </div>
                                <CabinDelegate v-for="cabin in cabins" :key="cabin.cabinKey" :prices="prices"
                                    :maxPeople="maxPeoplePerCabin" :initAdults="cabin.initAdults"
                                    :initChildren="cabin.initChildren" :initIndex="cabin.initIndex" @update-cabin="
                                        updateCabinData(cabin.cabinKey, $event)
                                        " @remove-cabin="removeCabin(cabin.cabinKey)" />
                                <div>
                                    <div class="btn btn--blue btn--standalone-tiny btn--block btn--rounded"
                                        @click="handleAddPrice()">
                                        {{ $t('LABELS.add-cabin') }}
                                    </div>
                                </div>
                            </div>
                            <form @submit.prevent="sendOrderForm">
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__header-column-part']">
                                    <Notification :text="error.text[LANGUAGE]" v-if="error.show"
                                        :initConfig="{ small: true }" @closed="closeNotification"></Notification>
                                    <div class="cruises-delegate-order-form__order-form__inputs">
                                        <div class="cruises-delegate-order-form__order-form__input-wrapper">
                                            <label for="first-name"
                                                class="cruises-delegate-order-form__order-form__label">{{
                                                    $t('LABELS.first-name')
                                                }}</label>
                                            <input type="text" id="first-name"
                                                class="cruises-delegate-order-form__order-form__input"
                                                v-model="firstName" required />
                                        </div>
                                        <div class="cruises-delegate-order-form__order-form__input-wrapper">
                                            <label for="last-name"
                                                class="cruises-delegate-order-form__order-form__label">{{
                                                    $t('LABELS.last-name') }}</label>
                                            <input type="text" id="last-name"
                                                class="cruises-delegate-order-form__order-form__input"
                                                v-model="lastName" required />
                                        </div>
                                        <div class="cruises-delegate-order-form__order-form__input-wrapper">
                                            <label for="email" class="cruises-delegate-order-form__order-form__label">{{
                                                $t('LABELS.email') }}</label>
                                            <input type="email" id="email"
                                                class="cruises-delegate-order-form__order-form__input" v-model="email"
                                                required />
                                        </div>
                                        <div class="cruises-delegate-order-form__order-form__input-wrapper">
                                            <label for="phone" class="cruises-delegate-order-form__order-form__label">{{
                                                $t('LABELS.phone-number')
                                                }}</label>
                                            <input type="tel" id="phone"
                                                class="cruises-delegate-order-form__order-form__input" v-model="phone"
                                                required />
                                        </div>
                                    </div>
                                    <div class="cruises-delegate-order-form__order-form__input-wrapper">
                                        <label for="message"
                                            class="cruises-delegate-order-form__order-form__label-message">{{
                                                $t('LABELS.message') }}</label>
                                        <textarea id="message" class="cruises-delegate-order-form__order-form__textarea"
                                            v-model="message"></textarea>
                                    </div>

                                    <div class="checkbox-agree">
                                        <input type="checkbox" class="checkbox-agree__checkbox" id="gdpr-agree"
                                            v-model="allowGDPR" />
                                        <label for="gdpr-agree" class="checkbox-agree__label">{{
                                            $t('TEXTS.agree-with-gdpr')
                                            }}
                                            <a href="https://info.costa-cruises.cz/ochrana-soukromi/"
                                                class="checkbox-agree__link" target="_blank">{{ $t('TEXTS.GDPR')
                                                }}</a></label>
                                    </div>
                                </div>

                                <div :class="delegatePageStyles['cruises-delegate-detail-page__prices']">
                                    <div :class="delegatePageStyles['cruises-delegate-detail-page__price-wrapper']">
                                        <div :class="[delegatePageStyles['cruises-delegate-detail-page__price'], delegatePageStyles['cruises-delegate-detail-page__price--discounted']]"
                                            v-if="
                                                details?.pricesFull?.single[
                                                    CURRENT_CURRENCY
                                                ].amount_decimal > 0
                                            " v-html="discountPriceMarkupComputed"></div>
                                        <div :class="delegatePageStyles['cruises-delegate-detail-page__price']" v-else>
                                            {{ formatPriceText(this.totalPrice) }}
                                        </div>
                                        <button type="submit"
                                            :class="delegatePageStyles['cruises-delegate-detail-page__price-btn']">
                                            {{ $t('LABELS.cruises-delegate-interested-button') }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div v-if="details?.conditions?.[LANGUAGE]"
                                :class="delegatePageStyles['cruises-delegate-detail-page__header-column-part']">
                                <div :class="delegatePageStyles['cruises-delegate-detail-page__conditions']"
                                    v-html="details?.conditions?.[LANGUAGE]"></div>
                            </div>
                        </div>
                    </div>
                    <router-link :to="{
                        path: '/plavby-s-delegatem',
                        query: $route.query,
                    }"
                        :class="[delegatePageStyles['cruises-delegate-detail-page__back-container'], delegatePageStyles['cruises-delegate-detail-page__back-container--cruises-delegate']]">
                        <svg
                            :class="[delegatePageStyles['cruises-delegate-detail-page__back-icon'], delegatePageStyles['cruises-delegate-detail-page__back-icon--cruises-delegate']]">
                            <use href="@/assets/imgs/icons/sprite.svg#back-arrow"></use>
                        </svg>
                        {{ $t('LABELS.back-to-search') }}
                    </router-link>
                </div>
            </div>
        </header>
        <main :class="['main', 'main--cruises-delegate', delegatePageStyles['cruises-delegate-detail-page']]">
            <main>
                <section class="cruises-delegate-detail__section">
                    <Itinerary :itinerary="this.itinerary"></Itinerary>
                </section>
                <section v-if="details?.sliderDescription?.[LANGUAGE]" class="cruises-delegate-detail__section">
                    <div class="cruises-delegate-detail__section-inner cruises-delegate-detail__wysiwyg"
                        v-html="details?.sliderDescription?.[LANGUAGE]"></div>
                </section>
                <section class="cruises-delegate-detail__section">
                    <div class="cruises-delegate-detail__section-inner">
                        <Gallery class="content-page__gallery" :images="details?.gallery?.map((img) => {
                            img.src = img.url;
                            return img;
                        })
                            " :type="TYPE" :loop="true" :delay="3000"></Gallery>
                        <Suspense>
                            <CruiseBanner class="cruises-delegate-detail__banner" />
                        </Suspense>
                    </div>
                </section>
                <section v-if="this.shipDetail" class="cruises-delegate-detail__section">
                    <div class="cruises-delegate-detail__section-inner">
                        <div class="cruiser-page__information">
                            <Swiper :slides-per-view="1" class="cabin-showcase__slider cruiser-page__information-slider"
                                :autoplay="{
                                    delay: 3000,
                                }" @swiper="saveInfoSwiper">
                                <button class="cabin-showcase__slider-btn cabin-showcase__slider-btn--prev" :class="{
                                    'cabin-showcase__slider-btn--disabled':
                                        infoSwiper?.isBeginning,
                                    'cabin-showcase__slider-btn--hidden':
                                        infoSwiper?.isBeginning &&
                                        infoSwiper?.isEnd,
                                }" @click="prevSlide(infoSwiper)">
                                    <svg class="cabin-showcase__slider-icon cabin-showcase__slider-icon--left">
                                        <use href="@/assets/imgs/icons/sprite.svg#simple-arrow"></use>
                                    </svg>
                                </button>
                                <Swiper-slide v-for="(imgUrl, i) in shipDetail.galleryImages" :key="i"><img
                                        :src="imgUrl" class="cabin-showcase__slide" /></Swiper-slide>
                                <button class="cabin-showcase__slider-btn cabin-showcase__slider-btn--next" :class="{
                                    'cabin-showcase__slider-btn--disabled':
                                        infoSwiper?.isEnd,
                                    'cabin-showcase__slider-btn--hidden':
                                        infoSwiper?.isEnd &&
                                        infoSwiper?.isBeginning,
                                }" @click="nextSlide(infoSwiper)">
                                    <svg class="cabin-showcase__slider-icon cabin-showcase__slider-icon--right">
                                        <use href="@/assets/imgs/icons/sprite.svg#simple-arrow"></use>
                                    </svg>
                                </button>
                            </Swiper>
                            <div class="cruiser-page__information-box">
                                <h2 class="cruiser-page__information-heading">
                                    {{ $t('LABELS.what-will-you-sail-on') }}
                                </h2>
                                <div class="cruiser-page__information-row" v-if="shipDetail.param_cabin_count">
                                    <p class="cruiser-page__information-label">
                                        {{ $t('LABELS.cabins-number') }}
                                    </p>
                                    <p class="cruiser-page__information-value">
                                        {{ shipDetail.param_cabin_count }}
                                    </p>
                                </div>
                                <div class="cruiser-page__information-row" v-if="shipDetail.param_length">
                                    <p class="cruiser-page__information-label">
                                        {{ $t('LABELS.ship-length') }}
                                    </p>
                                    <p class="cruiser-page__information-value">
                                        {{ shipDetail.param_length }}m
                                    </p>
                                </div>
                                <div class="cruiser-page__information-row" v-if="shipDetail.param_width">
                                    <p class="cruiser-page__information-label">
                                        {{ $t('LABELS.ship-width') }}
                                    </p>
                                    <p class="cruiser-page__information-value">
                                        {{ shipDetail.param_width }}m
                                    </p>
                                </div>
                                <div class="cruiser-page__information-row" v-if="shipDetail.param_passenger_count">
                                    <p class="cruiser-page__information-label">
                                        {{ $t('LABELS.passanger-count') }}
                                    </p>
                                    <p class="cruiser-page__information-value">
                                        {{ shipDetail.param_passenger_count }}
                                    </p>
                                </div>
                                <div class="cruiser-page__information-row" v-if="shipDetail.param_speed">
                                    <p class="cruiser-page__information-label">
                                        {{ $t('LABELS.speed-in-knots') }}
                                    </p>
                                    <p class="cruiser-page__information-value">
                                        {{ shipDetail.param_speed }}
                                    </p>
                                </div>
                                <div class="cruiser-page__information-row" v-if="shipDetail.param_tonne">
                                    <p class="cruiser-page__information-label">
                                        {{ $t('LABELS.weight') }}
                                    </p>
                                    <p class="cruiser-page__information-value">
                                        {{ shipDetail.param_tonne }}t
                                    </p>
                                </div>
                            </div>
                            <div class="cruiser-page__information-texts cruiser-page__wysiwyg"
                                v-html="shipDetail.text_one?.[LANGUAGE]"></div>
                        </div>
                    </div>
                </section>
                <CabinSection v-if="this.shipDetail" :shipCode="this.shipDetail.code"
                    class="cruises-delegate-detail__section" />
                <section class="cruises-delegate-detail__section">
                    <div class="cruises-delegate-detail__section-inner cruises-delegate-detail__wysiwyg"
                        v-html="details?.description?.[LANGUAGE]"></div>
                </section>
                <section class="cruises-delegate-detail__section">
                    <div class="cruises-delegate-detail__section-inner features-dash__container--grid">
                        <FeaturesDash v-if="details?.priceIncludedText"
                            :subHeading="$t('LABELS.services-basic-price-includes')"
                            :heading="$t('LABELS.basic-price-includes')" :features="details?.priceIncludedText.map(
                                (item) => item[LANGUAGE]
                            )
                                " type="includes"></FeaturesDash>
                        <FeaturesDash v-if="details?.priceExcludedText" :subHeading="$t('LABELS.additional-services')"
                            :heading="$t('LABELS.basic-price-excludes')" :features="details?.priceExcludedText.map(
                                (item) => item[LANGUAGE]
                            )
                                " type="additional"></FeaturesDash>
                    </div>
                </section>
                <section v-if="details?.delegateInfo?.name?.[LANGUAGE]"
                    class="cruises-delegate-detail__section cruises-delegate-detail__section--white">
                    <div class="contact-dash cruises-delegate-detail__section-inner">
                        <div class="contact-dash__part contact-dash__part--contact">
                            <div class="contact-dash__person-container">
                                <div class="contact-dash__img-container">
                                    <img :src="details?.delegateImage" class="contact-dash__img" />
                                </div>
                                <div class="contact-dash__person-info">
                                    <h3 class="contact-dash__name">
                                        {{ details?.delegateInfo.name[LANGUAGE] }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="contact-dash__part contact-dash__part--text">
                            <div class="contact-dash__info">
                                <h3 class="cruises-delegate-detail__contact-title">
                                    {{ $t('LABELS.your-delegate') }}
                                </h3>
                                <p class="contact-dash__info-text" v-html="details?.delegateInfo?.text[LANGUAGE]"></p>
                            </div>
                        </div>
                    </div>
                </section>
                <section v-if="details?.noteText?.[LANGUAGE]" class="cruises-delegate-detail__section">
                    <div class="cruises-delegate-detail__section-inner cruises-delegate-detail__wysiwyg"
                        v-html="details?.noteText?.[LANGUAGE]"></div>
                </section>
            </main>
        </main>
        <Footer></Footer>
        <LoadingManager ref="loadingManager"></LoadingManager>
    </div>
</template>
<script>
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { upperCaseFirst as upperCaseFirstUtil } from 'upper-case-first';
import Footer from '../../components/Footer';
import { Api } from '../../modules/Api';
import { Dictionary } from '../../modules/Dictionary';
import formatDateUtil from '../../utilities/formatDate';
import formatPriceUtil from '../../utilities/formatPrice';
import Gallery from '../../components/Gallery.vue';
import CabinDelegate from '@/components/CabinDelegate.vue';
import Itinerary from '../../components/Itinerary.vue';
import FeaturesDash from '../../components/FeaturesDash.vue';
import Notification from '../../components/Notification.vue';
import LoadingManager from '@/components/LoadingManager.vue';
import { Head } from '@vueuse/head';
import { TYPE, LANGUAGE } from '@/env';
import delegatePageStyles from '@/assets/sass/pages/cruises-delegate-detail-page.module.scss';
import CabinSection from '@/components/CabinSection.vue';
import { CURRENT_CURRENCY } from '@/utilities/currency';
import { defineAsyncComponent } from 'vue';
import SkeletonBox from '@/components/SkeletonBox.vue';

const dict = new Dictionary();

export default {
    props: ['special_cruise_code'],
    components: {
        Footer,
        Swiper,
        SwiperSlide,
        Head,
        Gallery,
        CabinDelegate,
        Itinerary,
        FeaturesDash,
        Notification,
        LoadingManager,
        CabinSection,
        CruiseBanner: defineAsyncComponent({
            loader: () => import(/** webpackChunkName: "CruiseBanner" */'@/components/CruiseBanner.vue'),
        }),
        SkeletonBox,
    },
    data() {
        return {
            api: new Api(this.$t),
            LANGUAGE: LANGUAGE,
            TYPE: TYPE,
            details: null,
            showStickyHeader: false,
            gallery: {
                show: false,
                images: [],
                imageIndex: 0,
            },
            swiper: null,
            includeTransport: false,
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            message: '',
            allowGDPR: false,
            error: {
                show: false,
                text: [],
            },
            prices: [],
            maxPeoplePerCabin: 4,
            totalPrice: 0,
            cabins: [],
            itinerary: [],
            shipDetail: null,
            infoSwiper: null,
            delegatePageStyles,
            CURRENT_CURRENCY,
            isInitialized: false,
            isLoading: true,
        };
    },
    methods: {
        upperCaseFirst(word) {
            return upperCaseFirstUtil(word);
        },
        saveSwiper(swiper) {
            this.swiper = swiper;
        },
        nextSlide(swiper) {
            swiper.slideNext();
        },
        prevSlide(swiper) {
            swiper.slidePrev();
        },
        inflect(word, num) {
            return dict.getWord(word, num, LANGUAGE);
        },
        daysInflected(days_num) {
            return dict.getWord('days', days_num, LANGUAGE);
        },
        formatDate(date) {
            return formatDateUtil(date);
        },
        formatPrice(price) {
            return formatPriceUtil(price);
        },
        showGallery(index) {
            this.gallery.imageIndex = index;
            this.gallery.show = true;
        },
        setGalleryImages() {
            this.gallery.images = this.details.gallery?.map((img) => img.url);
        },
        priceText(type) {
            if (this.details?.prices && this.details?.freeUnits) {
                if (this.details?.isSoldOut?.[type]) {
                    return this.$t('LABELS.soldout');
                }
                return `${this.formatPrice(
                    this.details.prices[type][CURRENT_CURRENCY]
                        .amount_decimal
                )} ${this.details.prices[type][CURRENT_CURRENCY].currency}`;
            }
            return '';
        },
        discountPriceMarkup(type) {
            return `
                  <span class='cruises-delegate-detail-page__price-discounted'>${this.formatPriceText(
                this.details?.prices[type][CURRENT_CURRENCY]
            )}</span>
                  <span class='cruises-delegate-detail-page__price-original'>${this.formatPriceText(
                this.details?.pricesFull[type][CURRENT_CURRENCY]
            )}</span>
              `;
        },
        formatPriceText(price) {
            return `${this.formatPrice(price)} ${CURRENT_CURRENCY === 'czk'
                ? 'Kč'
                : CURRENT_CURRENCY === 'eur'
                    ? '€'
                    : CURRENT_CURRENCY
                }`;
        },
        async sendOrderForm() {
            this.closeNotification();

            if (
                this.firstName === '' ||
                this.lastName === '' ||
                this.email === '' ||
                this.phone === ''
            ) {
                this.error.show = true;
                this.error.text = {
                    cs: [this.$t('ERRORS.fill-required')],
                    sk: [this.$t('ERRORS.fill-required')],
                };
                window.scrollTo(0, 0);
                console.error(
                    'Missing required fields:',
                    this.firstName,
                    this.lastName,
                    this.email,
                    this.phone
                );
                return false;
            }

            // Verify phone number format
            if (this.phone.split(' ').length > 1 || this.phone.length !== 9) {
                this.error.show = true;
                this.error.text = {
                    cs: [this.$t('ERRORS.wrong-phone-format')],
                    sk: [this.$t('ERRORS.wrong-phone-format')],
                };
                window.scrollTo(0, 0);
                console.error('Wrong phone number format:', this.phone);
                return false;
            }

            // Verify GDPR checkbox
            if (!this.allowGDPR) {
                window.scrollTo(0, 0);
                this.error.show = true;
                this.error.text = {
                    cs: [this.$t('ERRORS.agree-gdpr')],
                    sk: [this.$t('ERRORS.agree-gdpr')],
                };
                window.scrollTo(0, 0);
                console.error('User did not agree to GDPR');
                return false;
            }

            // Verify email ASCII
            if (
                !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(
                    this.email
                )
            ) {
                this.error.show = true;
                this.error.text = {
                    cs: [this.$t('ERRORS.invalid-email')],
                    sk: [this.$t('ERRORS.invalid-email')],
                };
                window.scrollTo(0, 0);
                console.error('Invalid email:', this.email);
                return false;
            }

            // Filter out empty cabins and cabin groups
            const filteredCabinData = this.cabins.filter(
                (cabin) => cabin.numAdults > 0 || cabin.numChildren > 0
            );

            // Check if there is at least one valid cabin left
            if (filteredCabinData.length === 0) {
                this.error.show = true;
                this.error.text = {
                    cs: [this.$t('ERRORS.empty-cabins')],
                    sk: [this.$t('ERRORS.empty-cabins')],
                };
                window.scrollTo(0, 0);
                console.error('No valid cabins left');
                return false;
            }

            const reqBody = {
                cruiseName: this.details?.name?.[LANGUAGE],
                cruiseCode: this.details?.code,
                cruiseId: this.details.id,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                message: this.message,
                cabins: filteredCabinData,
                currency: CURRENT_CURRENCY,
            };

            this.$refs.loadingManager.start(1);

            const resp = await this.$refs.loadingManager.addTask(
                this.$t('STATUSES.loading-cruise-info'),
                0,
                this.api.sendCruisesDelegateOrderForm(reqBody)
            );

            this.$refs.loadingManager.stop();

            if (!resp.data.send) {
                window.scrollTo(0, 0);
                this.error.show = true;
                this.error.text = {
                    cs: [this.$t('ERRORS.contact-form-send-fail')],
                    sk: [this.$t('ERRORS.contact-form-send-fail')],
                };
                window.scrollTo(0, 0);
                console.error('Contact form send failed');
                return false;
            }

            console.info('Contact form send success');
            this.$router.push('/plavba-s-delegatem-odeslano/');
        },
        closeNotification() {
            this.error.show = false;
            this.error.text = {
                cs: [],
                sk: [],
            };
        },
        calculateTotalPrice() {
            this.totalPrice = Object.values(this.cabins).reduce(
                (sum, cabin) => {
                    return sum + cabin.totalPrice ?? 0;
                },
                0
            );
        },
        getUniqueCabinId() {
            return Date.now() + Math.random();
        },
        handleAddPrice(adults = 0, children = 0, index = 0) {
            const newCabin = {
                cabinKey: this.getUniqueCabinId(),
                initAdults: adults,
                initChildren: children,
                initIndex: index,
            };
            this.cabins.push(newCabin);
        },
        saveInfoSwiper(swiper) {
            this.infoSwiper = swiper;
        },
        findAndAddCheapestCabin() {
            if (this.prices.length === 0) return;

            let cheapestPriceIndex = 0;
            let cheapestPrice = Infinity;

            // Find the index of the cheapest cabin
            this.prices.forEach((p, index) => {
                if (!p.availability) {
                    return;
                }

                const price = p.adult[0][CURRENT_CURRENCY].amount_decimal;
                if (price < cheapestPrice) {
                    cheapestPrice = price;
                    cheapestPriceIndex = index;
                }
            });

            // Add the cheapest cabin
            this.handleAddPrice(1, 0, cheapestPriceIndex);
            this.isInitialized = true;
        },
        updateCabinData(cabinKey, updatedCabin) {
            const index = this.cabins.findIndex((c) => c.cabinKey === cabinKey);
            if (index !== -1) {
                this.cabins[index] = { ...this.cabins[index], ...updatedCabin };
                this.calculateTotalPrice();
            }
        },
        removeCabin(cabinKey) {
            const index = this.cabins.findIndex((c) => c.cabinKey === cabinKey);
            if (index !== -1) {
                this.cabins.splice(index, 1);
                this.calculateTotalPrice();
            }
        },
    },
    async mounted() {
        this.$refs.loadingManager.start(4);

        const detailsPromise = this.$refs.loadingManager.addTask(
            this.$t('STATUSES.loading-cruise-info'),
            1,
            this.api
                .getCruisesDelegateDetail(this.special_cruise_code)
                .then((details) => {
                    if (!details) {
                        this.$router.push({
                            path: `/plavba-s-delegatem/${this.special_cruise_code}/nenalezeno/`,
                            query: this.$route.query,
                        });
                        return null;
                    }
                    this.details = { ...this.details, ...details };
                    return this.details;
                })
        );

        const pricesPromise = this.$refs.loadingManager.addTask(
            this.$t('STATUSES.loading-packages'),
            2,
            detailsPromise.then((details) => {
                if (details) {
                    return this.api
                        .getSpecialCruisePrices(details.id)
                        .then((prices) => {
                            this.prices = prices;
                        });
                }
            })
        );

        const itineraryPromise = this.$refs.loadingManager.addTask(
            this.$t('STATUSES.loading-itinerary'),
            3,
            detailsPromise.then((details) => {
                if (details) {
                    return this.api
                        .getSpecialCruiseItinerary(details.id)
                        .then((itinerary) => {
                            this.itinerary = itinerary;
                        });
                }
            })
        );

        const shipDetailPromise = this.$refs.loadingManager.addTask(
            this.$t('STATUSES.loading-ship-info'),
            4,
            detailsPromise.then((details) => {
                if (details) {
                    return this.api
                        .getShipDetail(details.ship_code)
                        .then((shipDetail) => {
                            this.shipDetail = shipDetail;
                        });
                }
            })
        );

        await Promise.all([
            detailsPromise,
            pricesPromise,
            itineraryPromise,
            shipDetailPromise,
        ]);

        if (
            this.details.transports?.bus?.[LANGUAGE] ||
            this.details.transports?.plane?.[LANGUAGE]
        ) {
            this.includeTransport = true;
        }

        this.setGalleryImages();
        this.findAndAddCheapestCabin();

        this.$refs.loadingManager.stop();
        this.isLoading = false;
    },
    computed: {
        discountPriceMarkupComputed() {
            return this.discountPriceMarkup('single');
        },
        priceObjects() {
            return this.prices.map((priceArray) => ({ fares: priceArray }));
        },
    },
    watch: {
        async special_cruise_code(newCode) {
            this.details = await this.api.getCruisesDelegateDetail(
                newCode
            );

            if (!this.details && this.$route.path.startsWith('/detail/')) {
                this.$router.push({
                    path: `/plavba-s-delegatem/${newCode}/nenalezeno/`,
                    query: this.$route.query,
                });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@/assets/sass/components/cabin-showcase';
</style>
